<template>
  <div>
    <v-row class=" ">
      <v-col cols="12" md="12">
        <template>
          <v-tabs color="primary" class="" height="80" background-color="#f4f4f4">
            <div class="d-flex align-center px-4">
              <v-icon color="primary " size="">mdi-storefront-outline</v-icon>
              <h5 class="font-weight-bold headline ml-2">
                {{ $t("allStores.mainTitle") }}
              </h5>
            </div>
          </v-tabs>
        </template>
      </v-col>
      <v-col cols="12" xs="12" md="5">
        <v-card-subtitle class="headline font-weight-bold">
          {{ $t("allStores.masterTitle") }}</v-card-subtitle>
        <div class="d-flex justify-space-between">
          <v-card width="500" elevation="1" class="mr-4 px-4 py-6 d-flex mx-4 text-decoration-none"
            @click="gotoEditStore(getMasterStore.id)">
            <v-img class="mr-5" max-width="100" contain :src="getMasterStore?.logo"></v-img>

            <div class="d-flex flex-column">
              <h1 class="headline">
                {{ getMasterStore?.name }}
                <v-chip v-if="this.getMasterStore?.master == true" small class="font-weight-bold white--text"
                  color="green" label>Master</v-chip>
              </h1>
              <v-breadcrumbs style="padding: 0px">https://{{ getMasterStore?.url }}.themediatrade.com/
                <v-btn icon :href="`https://${getMasterStore?.url}.themediatrade.com/`"
                  target="blank"><v-icon>mdi-open-in-new</v-icon></v-btn>
              </v-breadcrumbs>
            </div>
          </v-card>
        </div>
      </v-col>
      <v-col>
        <v-row>
          <v-col cols="12" md="8">
            <div class="d-flex align-baseline">
              <v-card-subtitle class="headline font-weight-bold">{{
                $t("allStores.subStoresTitle")
              }}</v-card-subtitle>
              <v-text-field v-if="stores.length > 2" hide-details class="mx-4" dense outlined
                :label="$t('allStores.searchLabel')" append-icon="mdi-magnify" v-model="subStores"></v-text-field>
            </div>
          </v-col>
        </v-row>
        <div class="d-flex flex-wrap px-4 align-center">
          <v-card v-for="item in findSubStore" :key="item.id" height="220" width="300"
            class="pa-4 pt-4 mr-4 mb-4 d-flex flex-column" style="place-content: space-between"
            @click="gotoEditStore(item.id)">
            <div class="pb-3">
              <v-img contain :src="item?.logo ? item.logo : item.item.logo" height="100"></v-img>
            </div>
            <div class="d-flex flex-column">
              <span class="black--text">{{
                item.name ? item.name : item.item.name
              }}</span>
              <span class="caption green--text font-weight-bold" v-html="loadStatus(item)"></span>
            </div>
          </v-card>
          <v-card height="220" min-width="300" elevation="0" class="grey lighten-3 d-flex mb-4" style="place-content: center"
            @click="(dialog = true), (show = true)" :disabled="$root.auth.type.access != 1">
            <div class="d-flex flex-column align-self-center">
              <v-dialog v-model="dialog" persistent max-width="600px">
                <v-card>
                  <v-card-title>
                    <span class="text-h5">{{
                      $t("allStores.addNewStore")
                    }}</span>
                  </v-card-title>
                  <v-card-text>
                    <v-container>
                      <v-row class="flex-column">
                        <form>
                          <v-col cols="12">
                            <v-text-field @input="v$.newStore.name.$touch()" @blur="v$.newStore.name.$touch()"
                              :errorMessages="nameErrors" :label="$t('allStores.newStoreName')" required
                              v-model="newStore.name"></v-text-field>
                          </v-col>
                          <v-col cols="12">
                            <v-text-field @input="v$.newStore.document.$touch()" @blur="v$.newStore.document.$touch()"
                              :errorMessages="documentErrors" label="CNPJ" required
                              v-model="newStore.document"></v-text-field>
                          </v-col>
                          <v-col cols="12">
                            <v-text-field @input="v$.newStore.url.$touch()" @blur="v$.newStore.url.$touch()"
                              :errorMessages="urlErrors" :label="$t('allStores.newStoreLink')" required
                              :hint="`https://${newStore.url}.themediatrade.com`" v-model="newStore.url"></v-text-field>
                          </v-col>
                          
                          <v-col cols="12">
                            <template v-if="show">
                              <Upload mime="'image/*'" :path="'/store/logo'" type="image"
                                @change-url="newStore.logo = $event" :snap="newStore.logo"></Upload>
                              <div class="red--text body-2" v-for="error in logoErrors" :key="error">{{ error }}</div>
                            </template>
                          </v-col>
                        </form>
                      </v-row>
                    </v-container>
                  </v-card-text>
                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn text @click="dialog = false">
                      {{ $t("common.cancel") }}
                    </v-btn>
                    <v-btn color="success" elevation="0" @click="saveNewStore()">
                      {{ $t("common.save") }}
                    </v-btn>
                  </v-card-actions>
                </v-card>
              </v-dialog>
              <v-icon class="black--text" x-large>mdi-plus-circle-outline</v-icon>
              <v-card-title class="title">{{
                $t("allStores.addNewStore")
              }}</v-card-title>
            </div>
          </v-card>
        </div>
      </v-col>
    </v-row>

    <template> </template>
  </div>
</template>

<script>
import useVuelidate from "@vuelidate/core";
import { required, numeric, minLength, maxLength } from "@vuelidate/validators";
import moment from "moment";
import Upload from "@/interface/FireUpload.vue";
import Fuse from "fuse.js";
import { mapActions } from "vuex";
import config from "@/store/config";
import { initializeApp } from "firebase/app";

import {
  getFirestore,
  collection,
  doc,
  query,
  where,
  setDoc,
  getDocs,
} from "firebase/firestore";
export default {

  name: 'allStores',

  setup() {
    return { v$: useVuelidate() };
  },

  validations() {
    return {
      newStore: {
        name: { required, minLength: minLength(2), maxLength: maxLength(100) },
        url: { required, minLength: minLength(2), maxLength: maxLength(50) },
        logo: { required },
        document: {}
      },
    };
  },
  components: {
    Upload,
  },
  data() {
    return {
      newStore: {
        name: "",
        url: "",
        document: "",
        logo: "",
      },
      stores: [],
      subStores: "",
      dialog: false,

      show: false,
    };
  },

  mounted() {
    this.loadAccount();
  },

  computed: {
    nameErrors() {
      const errors = [];
      if (!this.v$.newStore.name.$dirty) return errors;
      this.v$.newStore.name.minLength.$invalid &&
        errors.push(
          this.$t("allStores.err.minLengthName", {
            count: 2,
          })
        );
      this.v$.newStore.name.maxLength.$invalid &&
        errors.push(
          this.$t("allStores.err.maxLengthName", {
            count: 100,
          })
        );
      this.v$.newStore.name.required.$invalid &&
        errors.push(this.$t("allStores.err.requiredName"));
      return errors;
    },
    urlErrors() {
      const errors = [];
      if (!this.v$.newStore.url.$dirty) return errors;
      this.v$.newStore.url.minLength.$invalid &&
        errors.push(
          this.$t("allStores.err.minLengthUrl", {
            count: 2,
          })
        );
      this.v$.newStore.url.maxLength.$invalid &&
        errors.push(
          this.$t("allStores.err.maxLengthUrl", {
            count: 100,
          })
        );
      this.v$.newStore.url.required.$invalid &&
        errors.push(this.$t("allStores.err.requiredUrl"));
      return errors;
    },

    logoErrors() {
      const errors = [];
      if (!this.v$.newStore.logo.$dirty) return errors;

      this.v$.newStore.logo.required.$invalid &&
        errors.push(this.$t("allStores.err.requiredLogo"));
      return errors;
    },

    findSubStore() {
      let storeName = this.getSubStore.map((arr) => {
        return {
          name: arr.name,
          id: arr.id,
          logo: arr.logo,
          status: arr.status,
        };
      });
      const fuseConfig = {
        threshold: 0.5,
        location: 0,
        distance: 100,
        maxPatternLength: 32,
        minMatchCharLength: 1,
        keys: ["name"],
      };

      const fuse = new Fuse(storeName, fuseConfig);

      if (!this.subStores) {
        return storeName.map((arr) => {
          return arr;
        });
      }
      let fuseData = fuse.search(this.subStores);
      return fuseData;
    },

    getMasterStore() {
      const { stores } = this;
      return stores.filter((obj) => {
        return obj.master == true;
      })[0];
    },
    getSubStore() {
      const { stores } = this;
      return stores.filter((obj) => {
        return obj.master == false;
      });
    },
  },

  methods: {
    ...mapActions("snackbar", ["showSnack"]),
    ...mapActions("groupStores", ["getSelectedStore"]),

    gotoEditStore(store) {
      this.getSelectedStore(store);
      this.$router.push("/settings");
    },

    loadStatus(u) {
      console.log("U", u);
      let res = null;
      if (u.hasOwnProperty("status")) {
        if (u.status == "published") {
          res = `<span class="green--text">${this.$t(
            "allStores.activeStore"
          )}</span>`;
        } else {
          res = `<span class="red--text">${this.$t(
            "allStores.inactiveStore"
          )}</span>`;
        }
      } else {
        if (u.item.status == "published") {
          res = `<span class="green--text">${this.$t(
            "allStores.activeStore"
          )}</span>`;
        } else {
          res = `<span class="red--text">${this.$t(
            "allStores.inactiveStore"
          )}</span>`;
        }
      }
      console.log("res", res);
      return res;
    },
    saveNewStore() {
      this.v$.$touch()
      if (!this.v$.$invalid) {
        const Form = JSON.parse(JSON.stringify(this.getMasterStore))
        Form.name = this.newStore.name
        Form.id = this.newStore.url
        Form.url = this.newStore.url
        Form.logo = this.newStore.logo
        Form.document = this.newStore.document
        Form.companyInfo.footerText = ""
        Form.master = false
        for(let k in Form.companyInfo.socialMedia){
          Form.companyInfo.socialMedia[k] = ""
        }
        Form.info.about = []
        Form.locations = []
        Form.packagesSorter = []
        Form.packageSorter = []
        Form.seo.allKeywords = []
        Form.seo.description = ""
        Form.seo.subtitle = ""
        Form.seo.title = this.newStore.name
        Form.createdOn = moment().format()
        Form.updatedOn = moment().format()


        if (config) {


          const firebase = initializeApp(config);

          // Form.status = "inactive";
          console.log(Form);
          const db = getFirestore(firebase);
          setDoc(doc(db, "stores", Form.id), Form)
            .then(() => {
              this.loadAccount();
            })
            .then(() => {
              this.dialog = false;
              this.showSnack({
                text: this.$t("allStores.snackMessages.storeAdded"),
                color: "success",
                timeout: 2800,
                icon: "mdi-check",
              });
            });
        }
      }

    },

    loadAccount() {
      if(config){
      // Initialize Firebase
      const firebase = initializeApp(config);
      const db = getFirestore(firebase);
      const q = query(collection(db, "stores"));
      const querySnapshot = getDocs(q);
      const stores = [];
      querySnapshot.then((docs) => {
        docs.forEach((doc) => {
          stores.push(doc.data());
          if (doc.data().stores) {
            this.stores = doc.data();
            console.log("stores", doc.data());
          }
        });
        this.stores = stores;
      });
    }
    },
  },
};
</script>

<style lang="scss" scoped></style>
